<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">财务透明化</div>
                     <div class="title-e">FINANCIAL TRANSPARENCY</div>
                     <div class="title-line"></div>
                 </div>
                 <div class="end-rukou">
                    <!--我是后台系统入口<span class="icon-img"></span>-->
                 </div>
             </div>
             <div class="describe">
                 新能源城市配送共享服务平台支持企业管理人员对企业员工的收支管理以及结算等操作，企业管理人员还可实时查看企业的账务明细，方便企业进行财务核算，为企业提供在线申请发票的便捷入口。
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon431"></span> 收入结算
                 </div>
                 <div class="row-item">
                     <span class="icon-img icon432"></span> 成本结算
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon433"></span>
                     工资结算
                 </div>
                 <div class="row-item">
                     <span class="icon-img icon434"></span>
                     财务核算
                 </div>
             </div>


             <div class="data-describe">
                 <div class="data-box data-one">
                     <div class="data-num data-text">在线对账</div>
                     <div class="data-synopsis">
                         <p>提供多维度财务报表</p>
                     </div>
                 </div>
                 <div class="data-line data-line-t"></div>
                 <div class="data-box data-t">
                     <div class="data-num data-text">实时查看</div>
                     <div class="data-synopsis">
                         <p>企业账户明细实时查看</p>
                     </div>
                 </div>
             </div>
             <div class="img-describe img43"></div>
         </div>
    </div>

</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./../../../styles/public-item.less" lang="less" scoped></style>